import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

import ChangeRequests, { ChangeRequest } from "./ChangeRequests";
import {
  getLicenseChangeRequests,
  getAllLocations,
} from "../../../../services/locationApp/licenseService";
import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";

const ChangeRequestsContainer: React.FC = () => {
  const [requests, setRequests] = useState<ChangeRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [locationMap, setLocationMap] = useState<Record<string, string>>({});

  const getTokenFromCookies = (): string | null => {
    return Cookies.get("idToken") || null;
  };

  const fetchRequests = async () => {
    setLoading(true);
    setError("");

    try {
      const token = getTokenFromCookies();
      if (!token) throw new Error("Missing ID token");

      const [changeRequestRes, locationsRes] = await Promise.all([
        getLicenseChangeRequests(token),
        getAllLocations(token),
      ]);

      const locationMap: Record<string, string> = {};
      (locationsRes.data?.data || []).forEach((loc: any) => {
        if (loc.id && loc.businessDisplayName) {
          locationMap[loc.id] = loc.businessDisplayName;
        }
      });

      const enrichedRequests = (changeRequestRes.data?.data || []).map(
        (req: ChangeRequest) => ({
          ...req,
          locationName:
            locationMap[req.locationId] || req.locationName || req.locationId,
        }),
      );

      setLocationMap(locationMap);
      setRequests(enrichedRequests);
    } catch (err) {
      console.error("❌ Error fetching change requests", err);
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = "Change Requests";
    fetchRequests();
  }, []);

  return (
    <ChangeRequests
      requests={requests}
      loading={loading}
      error={error}
      onReload={fetchRequests}
    />
  );
};

export default ChangeRequestsContainer;
